var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "tooltip" },
    [
      _c("pui-tooltip"),
      _c(
        "span",
        {
          directives: [
            {
              name: "pui-tooltip",
              rawName: "v-pui-tooltip",
              value: { message: _vm.message },
              expression: "{ message }",
            },
          ],
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }